import Lenis from "lenis";

export const CONTACT = {
  phone: "+39 351 699 7493",
  whatsapp: "393516997493",
  email: "mimultiservice6@gmail.it",
  vat: "12681320961",
  area: "Milano e limitrofe",
};

export const SERVICES = [
  { id: "civ-uffici", cat: "civile", title: "Uffici e studi professionali", desc: "Scrivanie, postazioni, aree break, bagni e pavimenti: ambienti di lavoro sempre in ordine." },
  { id: "civ-condomini", cat: "civile", title: "Condomini e scale", desc: "Androni, pianerottoli, ascensori, cortili e vetri comuni, con frequenza concordata." },
  { id: "civ-case", cat: "civile", title: "Case e appartamenti", desc: "Pulizia ordinaria o a fondo di abitazioni e cambi inquilino." },
  { id: "civ-divani", cat: "civile", title: "Lavaggio divani e materassi", img: "/img/divani.jpg", desc: "Lavaggio a iniezione-estrazione di divani, poltrone, materassi e tappezzerie: via macchie, acari e odori." },
  { id: "civ-cantiere", cat: "civile", title: "Post-cantiere e ristrutturazione", desc: "Rimozione di polveri, residui di calce, pittura e sporco di cantiere." },
  { id: "ind-disinfestazione", cat: "industriale", title: "Disinfestazione e pest control", img: "/img/disinfestazione.jpg", desc: "Derattizzazione, trattamenti contro blatte, formiche, zanzare e cimici dei letti, monitoraggio periodico per aziende, condomini e abitazioni." },
  { id: "ind-capannoni", cat: "industriale", title: "Capannoni e magazzini", desc: "Lavaggio meccanizzato di grandi superfici, corsie, banchine e aree di carico." },
  { id: "ind-produzione", cat: "industriale", title: "Reparti produttivi", desc: "Pulizia di aree di produzione, macchinari esterni, spogliatoi e servizi." },
  { id: "ind-sanificazione", cat: "industriale", title: "Sanificazione ambienti", desc: "Igienizzazione di locali, superfici di contatto e spazi condivisi." },
  { id: "ind-pavimenti", cat: "industriale", title: "Trattamento pavimenti", desc: "Lavaggio, deceratura, ceratura e lucidatura di pavimenti civili e industriali." },
];

export const serviceTitle = (id) => SERVICES.find((s) => s.id === id)?.title ?? id;

export const whatsappLink = (ids = []) => {
  const list = ids.map((id) => `• ${serviceTitle(id)}`).join("\n");
  const text = ids.length
    ? `Ciao Mister Multiservice, vorrei un preventivo per:\n${list}`
    : "Ciao Mister Multiservice, vorrei informazioni per un preventivo.";
  return `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;
};

let lenis = null;
export const startLenis = () => {
  lenis = new Lenis({ duration: 1.2, smoothWheel: true });
  let id;
  const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
  id = requestAnimationFrame(raf);
  return () => { cancelAnimationFrame(id); lenis.destroy(); lenis = null; };
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
